import { useEffect } from 'react';

type HotkeyDefinition = {
  key: string;
  ctrlOrMeta?: boolean;
  shift?: boolean;
  alt?: boolean;
  handler: () => void;
};

export function useHotkeys(definitions: HotkeyDefinition[]) {
  useEffect(() => {
    function onKeyDown(event: KeyboardEvent) {
      const target = event.target as HTMLElement | null;
      const isTypingTarget =
        target instanceof HTMLInputElement ||
        target instanceof HTMLTextAreaElement ||
        target?.isContentEditable;

      for (const definition of definitions) {
        if (
          event.key.toLowerCase() === definition.key.toLowerCase() &&
          (!definition.ctrlOrMeta || event.ctrlKey || event.metaKey) &&
          (!definition.shift || event.shiftKey) &&
          (!definition.alt || event.altKey)
        ) {
          if (definition.ctrlOrMeta || !isTypingTarget) {
            event.preventDefault();
            definition.handler();
          }
        }
      }
    }

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [definitions]);
}

